import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { Cell } from 'components/HonestTable/HonestTable.styled'
import { NavBar } from 'components/NavBar/NavBar'
import { QuickFilter } from 'components/QuickFilter/QucikFilter'
import { useNavigate } from 'react-router-dom'
import { Button, Flex, H1WithBack, MainHeadline, PageWrapper, Tabs, TabsContainer } from 'styling/GlobalStyles'
import { BodyText } from 'styling/Typography'

interface IPermitRow {
    id: number
    type: string
    validFrom: string
    validTo: string
    scope: string
}

const mockPermits: IPermitRow[] = [
    { id: 1, type: 'Hot Work', validFrom: '2026-01-15', validTo: '2026-06-30', scope: 'Zone' },
    { id: 2, type: 'Confined Space Entry', validFrom: '2026-02-01', validTo: '2026-02-28', scope: 'Section' },
    { id: 3, type: 'Electrical Isolation', validFrom: '2026-03-10', validTo: '2026-12-31', scope: 'Blok' },
    { id: 4, type: 'Excavation', validFrom: '2026-04-01', validTo: '2026-09-15', scope: 'Pit' },
    { id: 5, type: 'Lifting Operations', validFrom: '2026-05-01', validTo: '2026-05-31', scope: 'Zone' },
]

const columns: IHonestTableColumn<IPermitRow>[] = [
    {
        id: 'type',
        header: 'Type',
        sortable: true,
        sticky: true,
        minWidth: '12rem',
        cell: (item) => (
            <Cell>
                <BodyText weight='600'>{item.type}</BodyText>
            </Cell>
        ),
    },
    {
        id: 'validFrom',
        header: 'Valid from',
        sortable: true,
        minWidth: '12rem',

        cell: (item) => <BodyText>{item.validFrom}</BodyText>,
    },
    {
        id: 'validTo',
        header: 'Valid to',
        sortable: true,
        minWidth: '12rem',

        cell: (item) => <BodyText>{item.validTo}</BodyText>,
    },
    {
        id: 'scope',
        header: 'Scope',
        sortable: true,
        minWidth: '12rem',

        cell: (item) => <BodyText>{item.scope}</BodyText>,
    },
    {
        id: 'spacer',
        header: '',
        fill: true,
        cell: () => null,
    },
]

export const Permits = () => {
    const navigate = useNavigate()

    return <>
        <NavBar />
        <PageWrapper>
            <Flex between width='100%' mb='16'>
                <H1WithBack arrow title='Permits' />
                <Flex gap='1rem' >
                    <TabsContainer>
                        <Tabs active >All</Tabs>
                        <Tabs>Draft</Tabs>
                        <Tabs>Approved</Tabs>
                    </TabsContainer>
                    <Button orange onClick={() => navigate('add')} >Add</Button>
                </Flex>
            </Flex>
            <HonestTable
                columns={columns}
                data={mockPermits}
                keyField='id'
            />
        </PageWrapper>
    </>
}
